module.exports = __webpack_public_path__ + "static/Aneta_1_min-7ad396d136a994808adf20db0c36ca35.jpg";